import styled from 'styled-components';

export const Container = styled.div`
  box-sizing: border-box;
  border-radius: 16px;
  padding: 20px;

  background-color: var(--color-white);
`;

export const Wrapper = styled.div`
  display: grid;
  grid-row-gap: 20px;

  position: relative;
`;
